"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const configuration_1 = require("@common/configuration");
const units_service_1 = require("./units.service");
class ComplianceService extends units_service_1.UnitsService {
    constructor(token) {
        super(token);
        this.endpoint = configuration_1.Configuration.unitsServiceConfig().api;
        this.endpointV2 = configuration_1.Configuration.unitsServiceConfig().apiV2;
        this.unitService = new units_service_1.UnitsService(token);
    }
    //#region Permits
    async getPermitsByUnitId(unitId) {
        const response = await this.httpService.get(`${this.endpointV2}/unit-permits?sort=id&filter[unit_id]=${unitId}`, { headers: this.getHeaders() });
        response.data.data.map(async (x) => {
            x.attributes = await this.setAuditFields(x.attributes);
        });
        return response.data.data;
    }
    async getPermitTypes() {
        const response = await this.httpService.get(`${this.endpoint}/permit-types`, { headers: this.getHeaders() });
        return response.data.data;
    }
    async createPermits(permits, user) {
        const data = {
            data: permits.map((permit) => {
                return {
                    type: 'unit_permit',
                    attributes: {
                        unit_id: permit.attributes.unit_id,
                        permit_type: { id: permit.attributes.permit_type.id },
                        permit_number: permit.attributes.permit_number,
                        display: permit.attributes.display,
                        required: permit.attributes.required,
                        effective_date: permit.attributes.effective_date,
                        renewal_date: permit.attributes.renewal_date,
                        description: permit.attributes.description,
                        created_by: user,
                    },
                };
            }),
        };
        const response = await this.httpService.post(`${this.endpointV2}/unit-permits`, data, { headers: this.getHeaders() });
        return response.data.data;
    }
    async updatePermit(permit, user) {
        const data = {
            data: {
                type: 'unit_permit',
                id: permit.id,
                attributes: {
                    unit_id: permit.attributes.unit_id,
                    permit_type: { id: permit.attributes.permit_type.id },
                    permit_number: permit.attributes.permit_number,
                    display: permit.attributes.display,
                    required: permit.attributes.required,
                    effective_date: permit.attributes.effective_date,
                    renewal_date: permit.attributes.renewal_date,
                    description: permit.attributes.description,
                    modified_by: user,
                },
            },
        };
        const response = await this.httpService.patch(`${this.endpointV2}/unit-permits/${permit.id}`, data, { headers: this.getHeaders() });
        return response.data.data;
    }
    async deletePermit(permit) {
        const response = await this.httpService.delete(`${this.endpointV2}/unit-permits/${permit.id}`, { headers: this.getHeaders() });
        return response;
    }
    //#endregion
    //#region Property Taxes
    async getPropertyTaxesByUnitId(unitId) {
        const response = await this.httpService.get(`${this.endpoint}/unit-property-taxes?filter[unit_id]=${unitId}`, { headers: this.getHeaders() });
        response.data.data.map(async (x) => {
            x.attributes = await this.setAuditFields(x.attributes);
        });
        return response.data.data;
    }
    async getPropertyTaxTypes() {
        const response = await this.httpService.get(`${this.endpoint}/property-tax-types`, { headers: this.getHeaders() });
        return response.data.data;
    }
    async createPropertyTax(propertyTaxes, user) {
        const data = {
            data: propertyTaxes.map((tax) => {
                return {
                    type: 'unit_property_tax',
                    attributes: {
                        unit_id: tax.attributes.unit_id,
                        tax_type: { id: tax.attributes.tax_type.id },
                        tax_number: tax.attributes.tax_number,
                        display: tax.attributes.display,
                        effective_date: tax.attributes.effective_date,
                        renewal_date: tax.attributes.renewal_date,
                        description: tax.attributes.description,
                        created_by: user,
                    },
                };
            }),
        };
        const response = await this.httpService.post(`${this.endpoint}/unit-property-taxes`, data, { headers: this.getHeaders() });
        return response.data.data;
    }
    async updatePropertyTax(propertyTax, user) {
        const data = {
            data: {
                type: 'unit_property_tax',
                id: propertyTax.id,
                attributes: {
                    unit_id: propertyTax.attributes.unit_id,
                    tax_type: { id: propertyTax.attributes.tax_type.id },
                    tax_number: propertyTax.attributes.tax_number,
                    display: propertyTax.attributes.display,
                    effective_date: propertyTax.attributes.effective_date,
                    renewal_date: propertyTax.attributes.renewal_date,
                    description: propertyTax.attributes.description,
                    modified_by: user,
                },
            },
        };
        const response = await this.httpService.patch(`${this.endpoint}/unit-property-taxes/${propertyTax.id}`, data, { headers: this.getHeaders() });
        return response.data.data;
    }
    async deletePropertyTax(propertyTax) {
        const response = await this.httpService.delete(`${this.endpoint}/unit-property-taxes/${propertyTax.id}`, { headers: this.getHeaders() });
        return response;
    }
}
exports.ComplianceService = ComplianceService;
//# sourceMappingURL=compliance.service.js.map